export default "__VITE_ASSET__BpzMe7tR__"